export interface ExplanationVideoData {
  directSourceUrl: string
  embedUrl: string
  id?: string
  length: string
  poster: string
  title: string
  url: string
}

export enum ExplanationVideoId {
  BetterRateRefinance = "better-rate-refinance",
  CashOutRefinance = "cash-out-refinance",
  ConsolidatingDebt = "consolidating-debt",
  FixedVsAdjustable = "fixed-vs-adjustable",
  LoanEstimates = "loan-estimates",
  MakeABetterOffer = "make-a-better-offer",
  PointsAndCredits = "points-and-credits",
  RateLock = "rate-lock",
  ReasonsToRefinance = "reasons-to-refinance",
  SaveMoneyRefinance = "save-money-refinance",
  ShoppingForAHome = "shopping-for-a-home",
  ThirdPartyFees = "third-party-fees",
  WhatIsBetter2 = "what-is-better-2",
  WhoIsBetter = "who-is-better",
  WhyWereBetter = "why-were-better",
}

export const explanationVideos: Record<
  ExplanationVideoId,
  ExplanationVideoData
> = {
  "shopping-for-a-home": {
    id: "shopping-for-a-home",
    url: "https://player.vimeo.com/video/231570980?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231570980?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231570980.hd.mp4?s=6a3a9cd25524c833e5ec94eac9602df254324525&profile_id=174",
    poster: "https://media.better.com/video/shopping-for-a-home.jpg",
    title: "I'm shopping for a home",
    length: "00:56",
  },
  "rate-lock": {
    id: "rate-lock",
    url: "https://player.vimeo.com/video/231570861?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231570861?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231570861.hd.mp4?s=9b8f8571e5367d7ff78b1236e06854542acd56fb&profile_id=174",
    poster: "https://media.better.com/video/rate-lock.jpg",
    title: "Why do I need to lock a rate?",
    length: "00:57",
  },
  "loan-estimates": {
    id: "loan-estimates",
    url: "https://player.vimeo.com/video/231571084?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231571084?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231571084.hd.mp4?s=8281159d1756a94fc91c6d5b8d81da24844b88f5&profile_id=174",
    poster: "https://media.better.com/video/loan-estimates.jpg",
    title: "Why are “loan estimates” so important?",
    length: "01:08",
  },
  "fixed-vs-adjustable": {
    id: "fixed-vs-adjustable",
    url: "https://player.vimeo.com/video/231570915?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231570915?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231570915.hd.mp4?s=24318624ef943ca818e9a6322d13b55d8f85c1b7&profile_id=174",
    poster: "https://media.better.com/video/fixed-vs-adjustable.jpg",
    title: "The difference between “fixed rate” and “adjustable”",
    length: "01:37",
  },
  "points-and-credits": {
    id: "points-and-credits",
    url: "https://player.vimeo.com/video/231571022?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231571022?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231571022.hd.mp4?s=6b719ddd617dcbf94da5dc12de7d1790961b78c1&profile_id=174",
    poster: "https://media.better.com/video/points-and-credits.jpg",
    title: "What are points and credits?",
    length: "01:16",
  },
  "what-is-better-2": {
    id: "what-is-better-2",
    url: "https://player.vimeo.com/video/231885447?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/231885447?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231885447.sd.mp4?s=066070b9d23d9d507aae2b273cab96e3fe096c90&profile_id=165",
    poster: "https://media.better.com/video/what-is-better-2.jpg",
    title: "What is Better (Part 2)",
    length: "00:59",
  },
  "third-party-fees": {
    id: "third-party-fees",
    url: "https://player.vimeo.com/video/250347573?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250347573?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250347573.hd.mp4?s=199f3a026a5439673d3f9aade425487c2c3c7473&profile_id=174",
    poster: "https://media.better.com/video/third-party-fees.jpg",
    title: "What are Third-party Fees?",
    length: "01:13",
  },
  "cash-out-refinance": {
    id: "cash-out-refinance",
    url: "https://player.vimeo.com/video/250531839?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250531839?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250531839.hd.mp4?s=058e11b8725cf865e5ed4c5bc86b437b83a56d4b&profile_id=174",
    poster: "https://media.better.com/video/cash-out-refinance.jpg",
    title: "Why should I do a cash out refinance?",
    length: "00:48",
  },
  "better-rate-refinance": {
    id: "better-rate-refinance",
    url: "https://player.vimeo.com/video/250382559?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250382559?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250382559.hd.mp4?s=bfc2211bba79dbc13479e507322ea6032c57a8cb&profile_id=174",
    poster: "https://media.better.com/video/better-rate-refinance.jpg",
    title: "When should I refinance for a better rate or term?",
    length: "00:57",
  },
  "save-money-refinance": {
    id: "save-money-refinance",
    url: "https://player.vimeo.com/video/250382309?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250382309?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250382309.hd.mp4?s=be5eb1ad1950f6aa191c273935694d0d0c669f8e&profile_id=174",
    poster: "https://media.better.com/video/save-money-refinance.jpg",
    title: "When does refinancing save you money?",
    length: "01:13",
  },
  "who-is-better": {
    id: "who-is-better",
    url: "https://player.vimeo.com/video/247171394?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/247171394?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/247171394.hd.mp4?s=a41cb922f1022c5eea38fa921d7ee82b009bb13b&profile_id=175",
    poster: "https://media.better.com/video/who-is-better.jpg",
    title: "Who is Better?",
    length: "00:55",
  },
  "reasons-to-refinance": {
    id: "reasons-to-refinance",
    url: "https://player.vimeo.com/video/250382786?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250382786?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250382786.hd.mp4?s=b2723966da7de0345488f1bd19e0d8bd8c2a12de&profile_id=175",
    poster: "https://media.better.com/video/reasons-to-refinance.jpg",
    title: "When should I refinance?",
    length: "01:27",
  },
  "consolidating-debt": {
    id: "consolidating-debt",
    url: "https://player.vimeo.com/video/250381739?autoplay=1",
    embedUrl: "https://player.vimeo.com/video/250381739?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250381739.hd.mp4?s=882d08fb95d77f99cf3f011c997281680199a0ed&profile_id=175",
    poster: "https://media.better.com/video/reasons-to-refinance.jpg",
    title: "Why would I use a mortgage to consolidate debt?",
    length: "00:46",
  },
  "why-were-better": {
    id: "why-were-better",
    url: "https://vimeo.com/231885447/1fa6cca2ff?autoplay=1",
    embedUrl: "https://vimeo.com/231885447/1fa6cca2ff?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/231885447.hd.mp4?s=2b5587a9d98dbb96240f23a7fc2a874e66e9fff7&profile_id=175",
    poster: "https://media.better.com/video/why-were-better.jpg",
    title: "Why we're better",
    length: "00:59",
  },
  "make-a-better-offer": {
    id: "make-a-better-offer",
    url: "https://vimeo.com/250381943/fd34ccc941?autoplay=1",
    embedUrl: "https://vimeo.com/250381943/fd34ccc941?autoplay=1",
    directSourceUrl:
      "https://player.vimeo.com/external/250381943.hd.mp4?s=b6439d767e8e96b7c4fcf6106b48d284bc890404&profile_id=175",
    poster: "https://media.better.com/video/make-a-better-offer.jpg",
    title: "Make a better offer",
    length: "01:30",
  },
}
